import { useCallback } from 'react';
import useSWR from 'swr';
import { Agent } from '../types';
import { apiClient } from '../services/apiClient';

interface UseAgentReturn {
  agent: Agent | null;
  loading: boolean;
  error: Error | undefined;
  refresh: () => Promise<void>;
}

const agentFetcher = async (agentId: string): Promise<Agent | null> => {
  const result = await apiClient.getAgentById(agentId);
  return result ?? null;
};

export const useAgent = (agentId: string | undefined): UseAgentReturn => {
  const { data, error, isLoading, mutate } = useSWR<Agent | null, Error>(
    agentId ? `/api/v1/agents/${agentId}` : null,
    () => agentFetcher(agentId!),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      dedupingInterval: 5000,
    }
  );

  const agent = data ?? null;
  const loading = isLoading;

  const refresh = useCallback(async (): Promise<void> => {
    await mutate();
  }, [mutate]);

  return {
    agent,
    loading,
    error,
    refresh,
  };
};
